import { getConceptCodes } from "@intocare/datatypes/lib/code-system";
import { composeValueSet } from "@intocare/datatypes/lib/value-set";

import { OBSERVATION_TYPE } from "../../code-system/observation-type";

export const OBSERVATION_TYPE_DISPLAY = composeValueSet({
	name: "OBSERVATION_TYPE_DISPLAY",
	description: "Current selection of observation types for displaying observations.",
	system: OBSERVATION_TYPE,
	include: getConceptCodes(OBSERVATION_TYPE),
});
